import "./DocumentManagement.scss";
import React, {useEffect, useState} from "react";
import {Tabs} from "components/common";
import type {TabsProps} from "antd";

import {tabKeys} from "../../../../types/enums";
import {useAppDispatch, useAppSelector} from "redux/hooks";
import {setButtonsHeader, setSiderKey} from "redux/reducer/common";
import TextAway from "./components/TextAway/TextAway";
import TextArrives from "./components/TextArrives/TextArrive";

const DocumentManagement = () => {
  document.title = "Quản lý văn bản";
  const dispatch = useAppDispatch();
  const activeTab = useAppSelector(state => state.common.activeTab);
  useEffect(() => {
    if (
      activeTab == tabKeys.TEXT.TEXTARRIVE ||
      activeTab == tabKeys.TEXT.TEXTAWAY
    ) {
      dispatch(setButtonsHeader([]));
    }
  }, [activeTab]);
  useEffect(() => {
    dispatch(setSiderKey("vanBan"));
  }, []);

  const items: TabsProps["items"] = [
    {
      key: tabKeys.TEXT.TEXTARRIVE,
      label: `Văn bản đi `,
      children: <TextAway />,
    },
    {
      key: tabKeys.TEXT.TEXTAWAY,
      label: `Văn bản đến `,
      children: <TextArrives />,
    },
  ];
  return (
    <div className="shift page">
      <div className="main">
        <Tabs activeKey={activeTab} items={items} />
      </div>
    </div>
  );
};

export default DocumentManagement;
